import getEditorData from '../../Common/getEditorData';
import savePopulationData from '../../Common/savePopulationData';
import destroyPopulationData from '../../Common/destroyPopulationData';
import filterProfessions from '../../Common/filterProfessions';
import router from '../../../router/routes';
import axios from 'axios';

export default {
    namespaced: true,

    state: {
        populationId: '',
        fieldId: '',
        fields: [],
        fieldsForSelect: [],
        fieldLocation: '',
        fieldName: '',
        fieldType: '',
        fieldOptions: [],
        stepName: '',
        stepId: 0,
        sectionName: '',
        sectionId: '',
        cardName: '',
        cardId: '',
        profession: 1,
        professions: [],
        selectableProfessions: [],
        population: [],
        postData: [],
        published: false,
        route: '',
        deleteModal: false,
        hydrated: false,
        populations: []
    },

    getters: {
        selectableProfessions() {
            return filterProfessions();
        },

        fieldLocation(state) {
            return (
                '<b>Step</b>: ' +
                state.stepName +
                ' \\ ' +
                state.sectionName +
                ' \\ ' +
                state.cardName +
                ' \\ ' +
                state.fieldName
            );
        },

        postData(state) {
            return {
                field_id: state.fieldId,
                profession_id: state.profession,
                population: state.population,
                published: state.published
            };
        },

        publishedText(state) {
            if (state.published) {
                return 'Published';
            } else {
                return 'Not Published';
            }
        },

        route(state) {
            if (state.populationId) {
                return '/api/population/edit/' + state.populationId;
            } else {
                return '/api/population/create';
            }
        }
    },

    mutations: {
        setHydrated(state, value) {
            state.hydrated = value;
        },

        setFieldId(state, value) {
            state.fieldId = value;
        },

        setFieldType(state, value) {
            state.fieldType = value;
        },

        setFieldOptions(state, value) {
            state.fieldOptions = value;
        },

        setFields(state, value) {
            state.fields = value;
        },

        setFieldsForSelect(state, value) {
            state.fieldsForSelect = value;
        },

        setStepName(state, value) {
            state.stepName = value;
        },

        setStepId(state, value) {
            state.stepId = value;
        },

        setSectionName(state, value) {
            state.sectionName = value;
        },

        setSectionId(state, value) {
            state.sectionId = value;
        },

        setCardName(state, value) {
            state.cardName = value;
        },

        setCardId(state, value) {
            state.cardId = value;
        },

        setFieldName(state, value) {
            state.fieldName = value;
        },

        setProfession(state, value) {
            state.profession = value;
        },

        setProfessions(state, value) {
            state.professions = value;
        },

        setPopulation(state, value) {
            state.population = value;
        },

        clearPopulation(state) {
            state.population = [];
        },

        setPopulationId(state, value) {
            state.populationId = value;
        },

        setPublished(state, value) {
            state.published = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        },

        setPopulations(state, value) {
            state.populations = value;
        }
    },

    actions: {
        getData({ commit, getters, state, dispatch }, routerParamPopulationId) {
            commit('setHydrated', false);

            return new Promise((resolve) => {
                commit('overlay/toggle', true, { root: true });
                commit('setPopulationId', routerParamPopulationId);

                getEditorData(getters.route)
                    .then((response) => {
                        dispatch('setFields', response.data.data.fields);
                        commit('setProfessions', response.data.data.professions);

                        if (state.populationId) {
                            const population = response.data.data.population;
                            commit('setFieldName', population.field.name);
                            commit('setFieldId', population.field_id);
                            commit('setFieldType', population.field.type);
                            commit('setFieldOptions', population.field.options);
                            commit('setCardName', population.field.card.name);
                            commit('setCardId', population.field.card.id);
                            commit('setSectionName', population.field.card.section.name);
                            commit('setSectionId', population.field.card.section.id);
                            commit('setStepName', population.field.card.section.step.name);
                            commit('setStepId', population.field.card.section.step.id);
                            commit('setProfession', population.profession_id ? population.profession_id : 0);
                            commit('setPopulation', population.population);
                            commit('setPublished', population.published);
                        } else {
                            // Make sure we don't return previous creation data.
                            // If you remove this, and someone who has previously created a card
                            // returns to the creation form, the previous card's data will still be there.
                            commit('setFieldId', router.currentRoute.params.fieldToPopulate ? router.currentRoute.params.fieldToPopulate : '');
                            commit('setFieldName', '');
                            commit('setFieldType', '');
                            commit('setCardName', '');
                            commit('setCardId', 0);
                            commit('setSectionName', '');
                            commit('setSectionId', 0);
                            commit('setStepName', '');
                            commit('setStepId', 0);
                            commit('setProfession', 0);
                            commit('setPublished', 0);
                            commit('clearPopulation');
                        }

                        axios.get('/api/population/index')
                            .then(response => {
                                commit('setPopulations', response.data.data.populations);
                                commit('setHydrated', true);
                                commit('overlay/toggle', false, { root: true });
                                resolve();
                            });
                    });
            });
        },

        saveData({ getters, commit, dispatch }) {
            commit('setHydrated', false);
            savePopulationData('population', getters.route, getters.postData)
                .then((populationId) => {
                    if (router.currentRoute.name === 'PopulationEdit') {
                        dispatch('getData', populationId);
                    } else {
                        router.push('/population/edit/' + populationId);
                    }
                })
                .catch(() => {
                    commit('setHydrated', true);
                });
        },

        destroyData({ state }) {
            console.log(state.fieldId);
            destroyPopulationData(
                '/api/population/delete/' + state.populationId,
                state.fieldId
            )
                .then(() => {
                })
                .catch(() => {
                });
        },

        setFields({ commit, dispatch }, value) {
            return new Promise((resolve) => {
                commit('setFields', value);
                dispatch('setFieldsForSelect');
                resolve();
            });
        },

        setFieldsForSelect({ state }) {
            return new Promise((resolve) => {
                let ffs = [];

                state.fields.forEach(function(field) {
                    if (field && field.card && field.card.section) {
                        if (field.type === 'text'
                            || field.type === 'textarea'
                            || field.type === 'wysiwyg'
                            || field.type === 'group'
                        ) {
                            ffs.push({
                                id: field.id,
                                name: field.name,
                                group:
                                    field.card.section.step.name +
                                    ' \\ ' +
                                    field.card.section.name +
                                    ' \\ ' +
                                    field.card.name
                            });
                        }
                    }
                });

                state.fieldsForSelect = ffs;
                resolve();
            });
        }
    }
};
